import { useAppSelector } from "../store/store"
import AppLoader from "./app-loader/app-loader"
import { LoadingState } from "../store/slices/loading.slice"

function LoadingContainer() {
  const { open } = useAppSelector(
    (state: { loading: LoadingState }) => state.loading
  )

  return <AppLoader loading={open} />
}

export default LoadingContainer
